import styled from "styled-components";
import variables from "../../theme/variables";
export const ProductSlideContainer = styled.div`
  position: fixed;
  bottom: ${(props) => {
    if (props.contentStatus === "close") {
      return "100%";
    } else if (props.status) {
      return 0;
    } else {
      return "-100%";
    }
  }};
  opacity: ${(props) =>
    props.status && props.contentStatus !== "close" ? 1 : 0};
  left: 0;
  z-index: 99;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #000;
  transition: ${(props) => (props.contentStatus === "close" ? "0.6s" : "0.3s")}
    all ease-in-out;
  .content-motion {
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    top: ${(props) => {
      if (props.contentStatus) {
        return 0;
      } else if (props.contentStatus === "close") {
        return "-100%";
      } else {
        return "100%";
      }
    }};
    background: #000;
    transition: 0.3s all;
    .content {
      overflow-y: scroll;
      -ms-overflow-style: none;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
      opacity: ${(props) =>
        props.contentStatus && props.contentStatus !== "close" ? "1" : "0"};
      transition: 0.9s all;
      .post-box {
        padding-bottom: 32px;
        padding-top: 80px;
        .title {
          padding-bottom: 32px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: sticky;
          top: 0;
          background: #000;
          z-index: 1;
          .close {
            font-size: 26px;
            cursor: pointer;
          }
        }

        .alignfull {
          width: 100%;
          video {
            width: 100%;
          }
        }
        .aligncenter {
          text-align: center;
        }
        .alignright {
          text-align: right;
        }
        .alignleft {
          text-align: left;
        }
      }
    }
  }
  @media (max-width: 768px) {
    .content-motion {
      .content {
        padding-top: 0;
        .post-box {
          padding-bottom: 100px;
          img {
            max-width: 100%;
            height: auto;
          }
          video {
            max-width: 100%;
          }
        }
      }
    }
  }
`;
